import React from "react"
import styled from "styled-components"
import Img from "gatsby-image"

import ads from "../../../images/placead.jpg"

const Bannerstyled = styled.div`
  position: relative;
  min-height: ${props => (props.sub ? "60vh" : "0")};
  max-height: ${props => (props.sub ? "70vh" : "100vh")};
  .gatsby-image-wrapper,
  img {
    max-height: ${props => (props.sub ? "70vh" : "100vh")};
    min-height: ${props => (props.sub ? "60vh" : "0")};
    width: 100%;
  }
  > .gatsby-image-wrapper {
    height: ${props => (props.fullHeight ? "100vh" : "auto")} !important;
  }
  .content {
    position: absolute;
    top: 60%;
    transform: translateY(-50%);
    width: 100%;
  }
  h1 {
    font-weight: 700;
    margin-bottom: 0;
    font-size: 3rem;
  }
  p {
    font-size: 1.5rem;
    margin-top: 0;
  }
  margin-bottom: ${props => (props.fullHeight ? 0 : "4rem")};
  video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 0;
    object-fit: fill;
  }
`

export const Banner = ({ fluid, children, sub, fullHeight }) => (
  <Bannerstyled sub={sub} fullHeight={fullHeight}>
    {fluid ? <Img fluid={fluid} /> : <img src={ads} />}
    <div>{children}</div>
  </Bannerstyled>
)
